module.exports = __webpack_public_path__ + "static/furniture-zone-e8c7d578fec8fef2d164fa8894116424.jpg";